const splitHours = (hour) => {
  if( !['24h', 'closed'].includes(hour) ) {
    return hour.split(' - ');
  } else {
    return hour;
  }
};

export default splitHours;
